export const CAPTIONED_LOADER_SIZE = 80;

export const CAPTIONED_LOADER_CENTER = 40;

export const CAPTIONED_LOADER_GUIDE_RADIUS = 35;

export const CAPTIONED_LOADER_OUTER_RADIUS = 34;

export const CAPTIONED_LOADER_MIDDLE_RADIUS = 25;

export const CAPTIONED_LOADER_INNER_RADIUS = 16;

export const CAPTIONED_LOADER_SPIN_SIZE = `${CAPTIONED_LOADER_SIZE}px`;

export const CAPTIONED_LOADER_SPIN_CW = "ryde-captioned-loader-spin-cw";

export const CAPTIONED_LOADER_SPIN_CCW = "ryde-captioned-loader-spin-ccw";
